package nacholab.supplies.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
fun NLLoadingInLine(){
    SpanText("Loading...")
}